import { instance as axiosToken, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance";
import { instance as axios } from "../../config/axiosInstance";
// ---------my-Site-Api-----------------------
export const mySiteApi = async (data) => {
    const endPoint = `user/site/list` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};
// ---------my-Site-Details-Api-----------------------
export const mySiteDetailsApi = async (data) => {
    const endPoint = `user/site/details` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};

// -------------------------------------Repository------------------------------------------------------------------

// ---------my-Repository-folder-list-Api-----------------------
export const folderListApi = async (data) => {
    const endPoint = `user/document/folder` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};
// ---------my-Repository-File-list-Api-----------------------
export const fileListApi = async (data) => {
    const endPoint = `user/document` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};
